export var TokenType;
(function (TokenType) {
    TokenType["ILLEGAL"] = "ILLEGAL";
    TokenType["EOF"] = "EOF";
    // Identifiers + literals
    TokenType["IDENT"] = "IDENT";
    TokenType["NUMBER"] = "NUMBER";
    TokenType["STRING"] = "STRING";
    // Operators
    TokenType["ASSIGN"] = "ASSIGN";
    TokenType["ASSIGN_REF"] = "ASSIGN_REF";
    TokenType["ASSIGN_ANCHOR"] = "ASSIGN_ANCHOR";
    TokenType["PLUS"] = "+";
    TokenType["MINUS"] = "-";
    TokenType["SLASH"] = "/";
    TokenType["BANG"] = "!";
    TokenType["HASH"] = "#";
    TokenType["GT"] = ">";
    TokenType["LT"] = "<";
    TokenType["ASTERISK"] = "*";
    TokenType["EQ"] = "==";
    TokenType["NOT_EQ"] = "!=";
    TokenType["CARET"] = "^";
    // Delimiters
    TokenType["COMMA"] = ",";
    TokenType["DOT"] = ".";
    TokenType["SEMICOLON"] = ";";
    TokenType["LPAREN"] = "(";
    TokenType["RPAREN"] = ")";
    TokenType["LBRACE"] = "{";
    TokenType["RBRACE"] = "}";
    TokenType["LBRACKET"] = "[";
    TokenType["RBRACKET"] = "]";
    TokenType["COLON"] = ":";
    // we need to have special annoying syntax to support handlebars identifiers
    TokenType["OPEN_BLOCK"] = "<<";
    TokenType["CLOSE_BLOCK"] = ">>";
    // Keywords
    TokenType["FUNCTION"] = "FUNCTION";
    TokenType["LET"] = "LET";
    TokenType["IF"] = "IF";
    TokenType["ELSE"] = "ELSE";
    TokenType["RETURN"] = "RETURN";
    TokenType["TRUE"] = "TRUE";
    TokenType["FALSE"] = "FALSE";
    TokenType["DELETE"] = "DELETE";
})(TokenType || (TokenType = {}));
export const keywords = new Map();
keywords.set('fn', TokenType.FUNCTION);
keywords.set('let', TokenType.LET);
keywords.set('if', TokenType.IF);
keywords.set('else', TokenType.ELSE);
keywords.set('return', TokenType.RETURN);
keywords.set('true', TokenType.TRUE);
keywords.set('false', TokenType.FALSE);
keywords.set('delete', TokenType.DELETE);
export const lookupIdentifier = (ident) => {
    if (keywords.has(ident)) {
        return keywords.get(ident) || TokenType.ILLEGAL;
    }
    return TokenType.IDENT;
};
export const isLetter = (ch) => {
    if (!ch)
        return false;
    return /[a-zA-Z_]/.test(ch);
};
export const isDigit = (ch) => {
    if (!ch) {
        return false;
    }
    return /[0-9]/.test(ch);
};
export const isWhitespace = (ch) => {
    return ch === ' ' || ch === '\t' || ch === '\r' || ch === '\n';
};
export const newToken = (type, literal) => ({ type, literal });
//# sourceMappingURL=data:application/json;base64,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